module.exports = __webpack_public_path__ + "static/flags/IS-29eae328f2fac7ec30bb4b7a6aa2728e.gif";